export enum IconSizeEnum {
  default = '',
  xs = 'xs',
  small = 'small',
  medium = 'medium',
  large = 'large',
  xl = 'xl',
  xxl = 'xxl',
  logo = 'logo'
}
